import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import styles from './Components/CSS/BookCategory.module.css';
import { categories } from './Components/BookCategoryData';

const BookSlider = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [cardsPerView, setCardsPerView] = useState(3);
  const totalSlides = categories.length;
  const navigate = useNavigate();

  // Extend categories with dummy block
  const extendedCategories = [...categories, { id: 'dummy', name: '', image: '' }];

  useEffect(() => {
    const updateCardsPerView = () => {
      if (window.innerWidth <= 768) {
        setCardsPerView(1);
      } else if (window.innerWidth <= 1200) {
        setCardsPerView(2);
      } else {
        setCardsPerView(3);
      }
    };

    updateCardsPerView();
    window.addEventListener('resize', updateCardsPerView);

    return () => window.removeEventListener('resize', updateCardsPerView);
  }, []);

  const nextSlide = () => {
    setActiveSlide((prev) => {
      const maxSlides = totalSlides - cardsPerView + 1;
      return prev < maxSlides ? prev + 1 : prev;
    });
  };

  const prevSlide = () => {
    setActiveSlide((prev) => (prev > 0 ? prev - 1 : 0));
  };

  const handleCategoryClick = (category) => {
    if (category.id !== 'dummy') {
      // Navigate to category page with the category ID
      navigate(`/blogs-category/${category.name}`);
    }
  };

  return (
    <div className={styles.sliderSection}>
      <div className={styles.sliderHeader}>
        <h1 className={styles.sliderTitle}>Explore best E-books by categories</h1>
        <p className={styles.sliderSubtitle}>Best e-books you can find online</p>
      </div>

      <div className={styles.sliderContainer}>
        <button className={styles.prevButton} onClick={prevSlide}>
          <ChevronLeft className="w-6 h-6" />
        </button>

        <div className={styles.cardsContainer}>
          <div
            className={styles.cardsWrapper}
            style={{
              transform: `translateX(-${activeSlide * (280 + 24)}px)`,
            }}
          >
            {extendedCategories.map((category) => (
              <div
                key={category.id}
                className={`${styles.categoryCard} ${category.id !== 'dummy' ? styles.clickable : ''}`}
                onClick={() => handleCategoryClick(category)}
                role={category.id !== 'dummy' ? 'button' : undefined}
                tabIndex={category.id !== 'dummy' ? 0 : undefined}
                onKeyPress={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleCategoryClick(category);
                  }
                }}
              >
                <div className={styles.cardImageContainer}>
                  {category.id !== 'dummy' ? (
                    <>
                      <img src={category.image} alt={category.name} className={styles.cardImage} />
                      <div className={styles.cardOverlay}>
                        <h3 className={styles.cardTitle}>{category.name}</h3>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        </div>

        <button className={styles.nextButton} onClick={nextSlide}>
          <ChevronRight className="w-6 h-6" />
        </button>
      </div>

      <div className={styles.sliderDots}>
        {Array.from({ length: Math.ceil(categories.length / cardsPerView) }).map((_, index) => (
          <button
            key={index}
            className={index === Math.floor(activeSlide / cardsPerView) ? styles.activeDot : styles.dot}
            onClick={() => setActiveSlide(index * cardsPerView)}
          />
        ))}
      </div>
    </div>
  );
};

export default BookSlider;